export default __webpack_public_path__ + "static/media/logo.72798a24.svg";